import * as Sentry from '@sentry/browser';
import {
  NOT_FOUND,
  DataCapsule,
  FrameStorageStrategy,
} from 'data-capsule/dist/src/frame';
import wix from './wix';
import { KEY_PREFIX } from '../constants/visit-count-key';

export type VisitCount = ReturnType<typeof initVisitCount>;

export const initVisitCount = () => {
  const instanceId = wix.getInstanceId();
  const key = `${KEY_PREFIX}-${instanceId}`;

  const capsule = new DataCapsule({
    strategy: new FrameStorageStrategy(window.top, '*', wix.getCompId(), {
      connectionMaxTimeout: 7000,
    }),
    namespace: 'wix',
  });

  const getVisitObj = async (): Promise<{
    visitCount: number;
    lastUpdate?: any;
  }> => {
    try {
      return await capsule.getItem(key);
    } catch (e) {
      if (e === NOT_FOUND) {
        // do nothing
      } else {
        // known bug in ios/safari - due to a security limitation it can't communicate with the other frame and fails.
      }
      return { visitCount: 0 };
    }
  };

  const getVisitCount = async () => {
    Sentry.addBreadcrumb({
      category: 'visitCount',
      message: 'getVisitCount',
    });
    const { visitCount } = await getVisitObj();
    return visitCount;
  };

  function getTodayDate() {
    const currentTime = Date.now();
    return new Date(currentTime).toISOString().substring(0, 10);
  }

  const incVisitCount = async () => {
    Sentry.addBreadcrumb({
      category: 'visitCount',
      message: 'incVisitCount',
    });
    const todayDate = getTodayDate();
    const { visitCount, lastUpdate } = await getVisitObj();
    if (lastUpdate !== todayDate) {
      const newCount = visitCount + 1;
      try {
        await capsule.setItem(key, {
          visitCount: newCount,
          lastUpdate: todayDate,
        });
      } catch (e) {
        // do nothing.
        // known bug in ios/safari - due to a security limitation it can't communicate with the other frame and fails.
      }
    }
  };

  return {
    getVisitCount,
    incVisitCount,
  };
};
